import {
  colors,
  createStyles,
  makeStyles,
  Paper,
  PaperProps,
  Typography,
} from "@material-ui/core";
import clsx from "clsx";
import React from "react";

const useStyles = makeStyles(
  ({ typography: { pxToRem, ...typography }, ...theme }) =>
    createStyles({
      paperSituation: {
        padding: "0 1rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      paperSituationSuccess: {
        color: "#78C357",
        backgroundColor: "rgba(120,195,87,0.12)",
      },
      paperSituationError: {
        color: theme.palette.primary.main,
        backgroundColor: "rgba(195,12,12,0.12)",
      },
      paperSituationWarning: {
        color: theme.palette.secondary.main,
        backgroundColor: "rgba(255,167,34,0.12)",
      },
      paperSituationBlack: {
        color: colors.grey[700],
        backgroundColor: theme.palette.hexToRGBWithAlpha(
          colors.grey[900],
          0.12
        ),
      },
      paperSituationMiddleWarning: {
        color: colors.purple[700],
        backgroundColor: theme.palette.hexToRGBWithAlpha(
          colors.purple[900],
          0.3
        ),
      },
      paperSituationGrey: {
        color: colors.grey[700],
        backgroundColor: theme.palette.hexToRGBWithAlpha(colors.grey[900], 0.3),
      },
    })
);

export interface TagProps extends PaperProps {
  type: "error" | "success" | "warning" | "black" | "middle-warning" | "grey";
}

const Tag: React.FC<TagProps> = ({ type, children, className, ...props }) => {
  const classes = useStyles();
  return (
    <Paper
      elevation={0}
      className={clsx(
        classes.paperSituation,
        {
          [classes.paperSituationError]: type === "error",
          [classes.paperSituationSuccess]: type === "success",
          [classes.paperSituationWarning]: type === "warning",
          [classes.paperSituationBlack]: type === "black",
          [classes.paperSituationMiddleWarning]: type === "middle-warning",
          [classes.paperSituationGrey]: type === "grey",
        },
        className
      )}
      {...props}
    >
      <Typography align="center" variant="button">
        {children}
      </Typography>
    </Paper>
  );
};

export { Tag };
